// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import SortedTablePlugin from 'vue-sorted-table'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BackToTop from 'vue-backtotop'
import App from './App'
import VueRouter from 'vue-router'
import axios from 'axios'

import Main from './components/main.vue'
import Bitfinex from './components/bitfinex.vue'
import UpbitKRW from './components/upbit_krw.vue'
import UpbitBTC from './components/upbit_btc.vue'
import Bithumb from './components/bithumb.vue'
import Coinone from './components/coinone.vue'
import Cointop from './components/coin_top.vue'
import Notice from './components/notice.vue'
import BinanceBTC from './components/binance_btc.vue'
import BinanceBTCDetail from './components/binance_btc_detail.vue'
// import BTCHashrate from './components/btc_hashrate.vue'
import Markets from './components/markets.vue'
import TradeBithumb from './components/trade_bithumb.vue'
import NotFound from './components/notfound.vue'

import './assets/style.css'

require('es6-promise').polyfill()
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(SortedTablePlugin)
Vue.use(BackToTop)
Vue.prototype.$axios = axios

export const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Main },
    { path: '/bitfinex', component: Bitfinex },
    { path: '/upbit_krw', component: UpbitKRW },
    { path: '/upbit_btc', component: UpbitBTC },
    { path: '/bithumb', component: Bithumb },
    { path: '/coinone', component: Coinone },
    { path: '/coin_top', component: Cointop },
    { path: '/notice', component: Notice },
    { path: '/binance_btc', component: BinanceBTC },
    { path: '/binance_btc_detail', component: BinanceBTCDetail },
    { path: '/markets', component: Markets },
    { path: '/trade_bithumb', component: TradeBithumb },
    { path: '*', component: NotFound }
  ]
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js